<mat-chip-grid #chipGrid [disabled]="disable">
  <mat-chip-row
    (removed)="remove(credentials)"
    *ngFor="let credentials of credentials">
    {{credentials}}
    <button matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip-row>
  <input
    #credentialsInput
    [formControl]="credentialsControl"
    [matAutocomplete]="auto"
    [matChipInputFor]="chipGrid"
    [matChipInputAddOnBlur]="true"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [placeholder]="credentials.length > 0 ? '' : placeholder">
</mat-chip-grid>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
  <mat-option *ngFor="let fruit of filteredCredentialsList | async" [value]="fruit">
    {{fruit}}
  </mat-option>
</mat-autocomplete>
